<template>
  <li :class="objSet.classes" @click="onSelected">
    <template v-if="objSet.hasIcon">
      <img
        v-if="iconLoaded"
        :src="objSet.iconUrl | defaultIcon"
        class="icon highres"
        @click="onSelected"
        @error="
          () => {
            iconLoaded = false;
          }
        "
      />
      <img
        v-else
        :src="objSet.fallbackIconUrl | defaultIcon"
        @click="onSelected"
        class="icon lowres"
      />
    </template>
    <div class="title">{{ objSet.name }}</div>
    <SwitchControl class="switch" v-model="visible" v-if="objSet.isHideable" />

    <div class="status" :style="objSet.statusStyle">
      {{ objSet.status }}
    </div>
  </li>
</template>

<script>
import SwitchControl from '@/components/ui/control/SwitchControl.vue';

export default {
  name: 'MapSearchResult',
  components: {
    SwitchControl,
  },
  props: {
    objSet: { type: Object },
  },
  data: () => ({
    iconLoaded: true,
  }),
  filters: {
    defaultIcon: (url) => url || require('@/assets/searchable_object_default_icon.png'),
  },
  computed: {
    visible: {
      get() {
        return this.objSet.visible;
      },
      set(value) {
        this.$emit('toggle', {id: this.objSet.id, value});
      },
    },
  },
  methods: {
    onSelected() {
      if (this.objSet.id) {
        this.$emit('selected', this.objSet.id);
      }
    },
  },
};
</script>
<style scoped>
.icon {
  grid-area: icon;
  display: inline-block;
  width: 40px;
  height: 40px;
}

.title {
  grid-area: title;
  align-self: center;
}

.switch {
  grid-area: switch;
  align-self: center;
}

.status {
  grid-area: status;
  align-self: left;
  background-color: #ff0000;
  border-radius: 5px;
  padding: 3px 5px;
  font-size: 12px;
}

.section,
.sub-section {
  display: grid;
  grid-template-columns: auto 60px;
  grid-template-rows: auto;
  grid-template-areas: 'title switch';
  font-weight: bold;
  padding: 5px 20px;
  text-align: left;
}

.section {
  background-color: #224460;
  color: #ffffff;
}

.sub-section {
  background-color: #e5e5e5;
  color: black;
}

.section .status,
.sub-section .status {
  display: none;
}

.item-without-status {
  display: grid;
  grid-template-columns: 60px auto auto;
  grid-template-rows: auto auto;
  grid-template-areas: 'icon title switch' 'icon title switch';
  background-color: #ffffff;
  cursor: pointer;
  padding: 4px 20px;
  text-align: left;
}

.item-with-status {
  display: grid;
  grid-template-columns: 60px auto auto;
  grid-template-rows: auto auto;
  grid-template-areas: 'icon title switch' 'icon status status';
  background-color: #ffffff;
  cursor: pointer;
  padding: 4px 20px;
  text-align: left;
}

.item-without-status .status {
  display: none;
}

.item:hover {
  background-color: #00ffff;
}
</style>
